<template>
  <div class="full-page full_content" :class="{ 'nav-open': $sidebar.showSidebar }">
    <PulseLoader :loading="!loaded" :class="{hide: loaded}" quote="Action is the foundational key to all success" author="Pablo Picasso" profession="Spanish Painter" img="picasso.jpg"></PulseLoader>
    <div
      v-if="loaded"
      class="wrapper wrapper-full-page"
      @click="toggleSidebarPage"
    >
      <notifications></notifications>
      <div
        class="page-header header-filter"
        :class="setPageClass"
        filter-color="black"
        :style="setBgImage"
      >
        <div class="container md-offset">
          <zoom-center-transition
            :duration="pageTransitionDuration"
            mode="out-in"
          >
            <router-view></router-view>
          </zoom-center-transition>
        </div>
        <footer class="footer">
          <div class="container md-offset">
            <nav>
              <ul>
              </ul>
            </nav>
            <div class="copyright text-center bg-transparent">
              &copy; {{ new Date().getFullYear() }} Bizminer. All Rights
              Reserved.
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import Vuex, { mapActions } from 'vuex';
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import {PulseLoader} from '@/components'

export default {
  name: 'auth-layout',
  components: {
    PulseLoader,
  },
  props: {
    backgroundColor: {
      type: String,
      default: 'black',
    },
  },
  inject: {
    autoClose: {
      default: true,
    },
  },
  data() {
    return {
      loaded: false,
      preference: undefined,
      responsive: false,
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 300,
      year: new Date().getFullYear(),
    };
  },
  computed: {
    setBgImage() {
      let images = {
        Pricing: process.env.VUE_APP_BASE_URL + '/img/bg-pricing.jpg',
        Login: process.env.VUE_APP_BASE_URL + '/img/register.jpg',
        EmailSent: process.env.VUE_APP_BASE_URL + '/img/register.jpg',
        EmailConfirm: process.env.VUE_APP_BASE_URL + '/img/register.jpg',
        ForgotPassword: process.env.VUE_APP_BASE_URL + '/img/register.jpg',
        RecoverPassword: process.env.VUE_APP_BASE_URL + '/img/register.jpg',
        Register: process.env.VUE_APP_BASE_URL + '/img/register.jpg',
        Lock: process.env.VUE_APP_BASE_URL + '/img/lock.jpg',
      };
      return {
        backgroundImage: `url(${images[this.$route.name]})`,
      };
    },
    setPageClass() {
      return `${this.$route.name}-page`.toLowerCase();
    },
  },
  methods: {
    ...mapActions({
      alertSuccess: 'alerts/success',
      alertError: 'alerts/error',
    }),
    toggleSidebarPage() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    linkClick() {
      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    toggleNavbar() {
      document.body.classList.toggle('nav-open');
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove('nav-open');
      this.showMenu = false;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    getPreference() {
      this.$store
        .dispatch('authenticateUser')
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          if (!res) {
            this.$router.push({ path: 'login' });
            this.loaded = true;
          } else {
            this.preference =
              res.preferences.defaultScreen != ''
                ? '/' +
                  res.preferences.defaultScreen
                    .replace(/\s+/g, '-')
                    .toLowerCase()
                : 'Search';
            if (this.preference === '/subscription-activity') {
              this.preference = '/subscriptions';
            }

            this.$router.push({ path: this.preference });
            this.loaded = true;
          }
        })
        .catch((error) => {
          this.loaded = true;
        });
    },
  },
  created() {
    if (
      this.$router.history.current['path'] === '/' ||
      this.$router.history.current['path'] === ''
    ) {
      // this.loaded = false;
      this.getPreference();
    } else {
      this.loaded = true;
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener('resize', this.onResponsiveInverted);
  },
  beforeDestroy() {
    this.closeMenu();
    window.removeEventListener('resize', this.onResponsiveInverted);
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },
};
</script>
<style lang="scss" scoped>
$scaleSize: 0.1;
$zoomOutStart: 0.7;
$zoomOutEnd: 0.46;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}
.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}
@keyframes zoomOut8 {
  from {
    opacity: 1;
    transform: scale3d($zoomOutStart, $zoomOutStart, $zoomOutStart);
  }
  to {
    opacity: 0;
    transform: scale3d($zoomOutEnd, $zoomOutEnd, $zoomOutEnd);
  }
}
.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}
</style>
